// src/components/Services.js
import React from 'react';
import {
  Box,
  Heading,
  Text,
  SimpleGrid,
  VStack,
  Image,
  Link,
  Icon,
  Button,
  useColorModeValue,
  Flex,
  Circle,
} from '@chakra-ui/react';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import { BsBuilding, BsBrush, BsGear } from 'react-icons/bs';
import { Link as RouterLink } from 'react-router-dom'; // <<< 1. IMPORT ROUTER LINK

import industry from '../assets/industry.jpeg';
import commercial from '../assets/commercial.jpeg';
import renovation from '../assets/renovation.jpeg';

// --- COMPLETELY REBUILT ServiceCard COMPONENT ---
const ServiceCard = ({ icon, image, title, children, isFeatured }) => {
  const featuredBorderStyle = {
    borderColor: 'orange.400',
    borderWidth: '2px',
  };

  return (
    <VStack
      bg={useColorModeValue('white', 'gray.700')}
      borderRadius="xl" // Use a larger border radius
      boxShadow="lg"
      textAlign="center"
      transition="all 0.3s"
      _hover={{ transform: 'translateY(-5px)', boxShadow: 'xl' }}
      // Apply featured styles directly
      borderWidth="2px"
      borderColor={isFeatured ? 'orange.400' : 'transparent'}
      overflow="hidden" // Important for containing the custom shape
      spacing={0} // Remove default spacing
    >
      {/* Container for the image, overlay, and icon */}
      <Box position="relative" w="full">
        
        {/* This Box creates the custom curved shape for the image */}
        <Box
          h="150px"
          w="full"
          sx={{
            // The clip-path creates the unique curve at the bottom
            clipPath: "path('M 0 0 H 100 V 85 C 75 100, 25 100, 0 85 Z')",
            // Apply percentages for responsiveness
            clipPath: "path('M 0% 0% L 100% 0% L 100% 85% C 75% 100%, 25% 100%, 0% 85% Z')",
          }}
        >
          <Image src={image} alt={title} w="full" h="full" objectFit="cover" />
          {/* Dark gradient overlay */}
          <Box
            position="absolute"
            top="0"
            left="0"
            right="0"
            bottom="0"
            bgGradient="linear(to-t, blackAlpha.600, transparent)"
          />
        </Box>
        
        {/* The Icon Circle */}
        <Circle
          size="80px" // Larger icon circle
          bg="blue.800"
          color="white"
          position="absolute"
          bottom="-40px" // Positioned half on and half off
          left="50%"
          transform="translateX(-50%)"
          boxShadow="xl"
          border="4px solid"
          borderColor={useColorModeValue('white', 'gray.700')}
        >
          <Icon as={icon} w={9} h={9} />
        </Circle>
      </Box>

      {/* Container for the text content */}
      <VStack spacing={3} py={6} px={6} pt={16}> {/* Increased padding-top for the icon */}
        <Heading as="h3" size="md" fontWeight="extrabold" color={useColorModeValue('blue.900', 'white')}>
          {title}
        </Heading>
        <Text color="gray.500" fontSize="sm" minH="80px"> {/* Set min-height for alignment */}
          {children}
        </Text>
      </VStack>

      {/* Learn more link at the bottom */}
      <Link href="#" color="orange.500" fontWeight="bold" pb={6}>
        Learn more <Icon as={ArrowForwardIcon} verticalAlign="middle" />
      </Link>
    </VStack>
  );
};


export default function Services() {
  return (
    <Box as="section" py={{ base: 16, md: 24 }} px={8} id="services">
      <VStack spacing={4} textAlign="center">
        <Text color="orange.500" fontWeight="bold">Our Services</Text>
        <Heading as="h2" size="2xl" fontWeight="bold">
          Services That Fit Your Needs
        </Heading>
      </VStack>

      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 3 }}
        spacing={10}
        maxW="7xl"
        mx="auto"
        mt={16}
      >
        <ServiceCard
          icon={BsBuilding}
          title="Commercial Construction"
          image={commercial}
          isFeatured={true}
        >
          We specialize in constructing large-scale commercial properties, from modern office buildings to retail centers, tailored to your business needs.
        </ServiceCard>
      
        <ServiceCard
          icon={BsGear}
          title="Industrial Construction"
          image={industry}
        >
          Building robust industrial facilities, including warehouses, manufacturing plants, and distribution centers engineered for peak efficiency.
        </ServiceCard>

        <ServiceCard
          icon={BsBrush}
          title="Renovations and Remodeling"
          image={renovation}
        >
          Transforming existing spaces with high-quality finishes and modern designs to significantly enhance both functionality and property value.
        </ServiceCard>
      </SimpleGrid>

      <Flex justify="center" mt={12}>
    <Button
            as={RouterLink}      // <<-- ADD THIS
            to="/services"       // <<-- ADD THIS
            rightIcon={<ArrowForwardIcon />}
            colorScheme="orange"
            variant="solid"
            size="lg"
        >
            View All Services
        </Button>
      </Flex>
    </Box>
  );
}